import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import {
  getColorOptions,
  getFontSizeOptions,
  getFontStyleOptions,
  getFontWeightOptions,
  getLineHeightOptions,
  getTextAlignOptions,
  getTextDecorationOptions,
  getTextTransformOptions,
} from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "h2",
  props: {
    text: {
      prop: "other",
      type: "string",
      value: "H2 text",
    },
    headingLevel: {
      prop: "other",
      type: "heading-level-picker",
      value: "h2",
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        color: getColorOptions(defaultStyles.color),
        textTransform: getTextTransformOptions(defaultStyles.textTransform),
        fontStyle: getFontStyleOptions(defaultStyles.fontStyle),
        fontWeight: getFontWeightOptions(defaultStyles.fontWeight),
        fontSize: getFontSizeOptions(defaultStyles.fontSize),
        lineHeight: getLineHeightOptions(defaultStyles.lineHeight),
        textAlign: getTextAlignOptions(defaultStyles.textAlign),
        textDecoration: getTextDecorationOptions(defaultStyles.textDecoration),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
      },
    },
  },
};
